/**
 * Lupuloa Pack Builder - v15
 * v12: Escribe atributo 'pack-16' en Note Attributes del carrito
 * v13: Descuenta del stock disponible las unidades ya en el carrito
 * v14: Mueve updatePack16Attribute() DESPUÉS de applyDiscountCode()
 * v15: Escribe siempre 'pack-16: 1' fijo — elimina el contador incremental
 *      que causaba valores como pack-16: 5 cuando el cliente configuraba
 *      varios packs en la misma sesión
 */

class PackBuilder {
  constructor() {
    this.packSize = parseInt(document.querySelector('.pack-builder-container')?.dataset.packSize) || 12;
    this.discountCode = document.querySelector('.pack-builder-container')?.dataset.discountCode || null;
    this.selectedProducts = new Map();
    this.productsGrid = document.getElementById('products-grid');
    this.addPackButton = document.getElementById('add-pack-to-cart');
    this.checkoutButton = document.getElementById('pack-go-to-checkout');
    this.totalBeersEl = document.getElementById('total-beers');
    this.totalPriceEl = document.getElementById('total-price');
    this.messageEl = document.getElementById('pack-message');
    this.selectedBeersGrid = document.getElementById('selected-beers-grid');

    this.modal = document.getElementById('beer-info-modal');
    this.modalBackdrop = document.getElementById('beer-info-modal-backdrop');
    this.modalClose = document.getElementById('beer-info-modal-close');
    this.modalTitle = document.getElementById('beer-info-modal-title');
    this.modalDescription = document.getElementById('beer-info-modal-description');
    this.modalFormato = document.getElementById('beer-info-modal-formato');
    this.modalAlcohol = document.getElementById('beer-info-modal-alcohol');
    this.modalTipo = document.getElementById('beer-info-modal-tipo');

    this.cartQuantities = new Map();
    this.init();
  }

  async init() {
    if (!this.productsGrid) return;
    await this.loadCartQuantities();
    this.attachEventListeners();
    this.attachModalListeners();
    this.attachSlotListeners();
    this.updateUI();
    this.loadPresetFromURL();
  }

  async loadCartQuantities() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      this.cartQuantities = new Map();
      cart.items.forEach(item => {
        const id = String(item.variant_id);
        const existing = this.cartQuantities.get(id) || 0;
        this.cartQuantities.set(id, existing + item.quantity);
      });
    } catch(e) {
      console.warn('No se pudo cargar el carrito:', e);
    }
  }

  getAvailableStock(productId, totalStock) {
    if (totalStock <= 0) return 999;
    const inCart = this.cartQuantities.get(String(productId)) || 0;
    return Math.max(0, totalStock - inCart);
  }

  loadPresetFromURL() {
    const params = new URLSearchParams(window.location.search);
    const presetName = params.get('preset');
    const skus = params.get('skus');
    if (skus) { this._loadPresetBySKU(skus, presetName); return; }
    const items = params.get('items');
    if (items) { this._loadPresetByVariantId(items, presetName); }
  }

  _loadPresetBySKU(skusParam, presetName) {
    const pairs = skusParam.split(',');
    const toLoad = [];
    pairs.forEach(function(pair) {
      const parts = pair.trim().split(':');
      const sku = parts[0];
      const qty = parseInt(parts[1]) || 1;
      if (sku) toLoad.push({ sku, qty });
    });
    if (toLoad.length === 0) return;
    if (presetName) this.showMessage('Cargando pack "' + presetName + '"...', 'info');
    setTimeout(() => {
      let loaded = 0;
      toLoad.forEach(({ sku, qty }) => {
        const card = this.productsGrid.querySelector('[data-product-sku="' + sku + '"]');
        if (!card) { console.warn('Pack preset: SKU no encontrado:', sku); return; }
        for (let i = 0; i < qty; i++) {
          if (this.getTotalSelected() < this.packSize) { this.addProduct(card); loaded++; }
        }
      });
      if (loaded > 0) {
        this.showMessage('¡Pack "' + (presetName || 'Pack predefinido') + '" cargado! Puedes modificarlo a tu gusto.', 'success');
      }
    }, 300);
  }

  _loadPresetByVariantId(itemsParam, presetName) {
    const pairs = itemsParam.split(',');
    const toLoad = [];
    pairs.forEach(function(pair) {
      const parts = pair.trim().split(':');
      const variantId = parts[0];
      const qty = parseInt(parts[1]) || 1;
      if (variantId) toLoad.push({ variantId, qty });
    });
    if (toLoad.length === 0) return;
    if (presetName) this.showMessage('Cargando pack "' + presetName + '"...', 'info');
    setTimeout(() => {
      let loaded = 0;
      toLoad.forEach(({ variantId, qty }) => {
        const card = this.productsGrid.querySelector('[data-product-id="' + variantId + '"]');
        if (!card) return;
        for (let i = 0; i < qty; i++) {
          if (this.getTotalSelected() < this.packSize) { this.addProduct(card); loaded++; }
        }
      });
      if (loaded > 0 && presetName) {
        this.showMessage('¡Pack "' + presetName + '" cargado! Puedes modificarlo a tu gusto.', 'success');
      }
    }, 300);
  }

  openModal(card) {
    const title = card.dataset.productTitle || '';
    const description = card.dataset.productDescription || '';
    const formato = card.dataset.productFormato || '';
    const alcohol = card.dataset.productAlcohol || '';
    const tipo = card.dataset.productTipo || '';
    this.modalTitle.textContent = title;
    this.modalDescription.textContent = description;
    this.modalFormato.textContent = formato ? 'Formato: ' + formato : '';
    this.modalAlcohol.textContent = alcohol ? '% Alcohol: ' + alcohol : '';
    this.modalTipo.textContent = tipo ? 'Tipo: ' + tipo : '';
    this.modalFormato.style.display = formato ? '' : 'none';
    this.modalAlcohol.style.display = alcohol ? '' : 'none';
    this.modalTipo.style.display = tipo ? '' : 'none';
    this.modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  closeModal() {
    this.modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  attachModalListeners() {
    if (!this.modal) return;
    this.modalClose.addEventListener('click', () => this.closeModal());
    this.modalBackdrop.addEventListener('click', () => this.closeModal());
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.closeModal(); });
    this.productsGrid.addEventListener('click', (e) => {
      const btn = e.target.closest('.btn-add-corner, .btn-remove-corner');
      if (btn) return;
      const wrapper = e.target.closest('.product-image-wrapper');
      if (!wrapper) return;
      const card = wrapper.closest('.product-card');
      if (card) this.openModal(card);
    });
  }

  attachSlotListeners() {
    if (!this.selectedBeersGrid) return;
    this.selectedBeersGrid.addEventListener('click', (e) => {
      const slot = e.target.closest('.beer-slot.filled');
      if (!slot) return;
      const productId = slot.dataset.productId;
      if (!productId) return;
      const card = this.productsGrid.querySelector(`[data-product-id="${productId}"]`);
      if (card) this.removeProduct(card);
    });
  }

  attachEventListeners() {
    this.productsGrid.addEventListener('click', (e) => {
      const addButton = e.target.closest('.btn-add-corner');
      const removeButton = e.target.closest('.btn-remove-corner');
      if (addButton) {
        const card = addButton.closest('.product-card');
        if (card) this.addProduct(card);
      } else if (removeButton) {
        const card = removeButton.closest('.product-card');
        if (card) this.removeProduct(card);
      }
    });
    if (this.addPackButton) this.addPackButton.addEventListener('click', () => this.addPackToCart(false));
    if (this.checkoutButton) this.checkoutButton.addEventListener('click', () => this.addPackToCart(true));
  }

  addProduct(productCard) {
    const productId = productCard.dataset.productId;
    const totalStock = parseInt(productCard.dataset.productStock) || 0;
    const availableStock = this.getAvailableStock(productId, totalStock);
    const totalSelected = this.getTotalSelected();
    if (totalSelected >= this.packSize) {
      this.showMessage(`Ya has seleccionado ${this.packSize} cervezas.`, 'warning');
      return;
    }
    let product = this.selectedProducts.get(productId);
    const currentQty = product ? product.quantity : 0;
    if (totalStock > 0 && currentQty >= availableStock) {
      const inCart = this.cartQuantities.get(String(productId)) || 0;
      if (inCart > 0) {
        this.showMessage(`Solo quedan ${availableStock} unidades disponibles (tienes ${inCart} en el carrito).`, 'warning');
      } else {
        this.showMessage(`Solo quedan ${availableStock} unidades disponibles de esta cerveza.`, 'warning');
      }
      return;
    }
    if (!product) {
      product = {
        title: productCard.dataset.productTitle,
        quantity: 0,
        image: productCard.dataset.productImage,
        price: parseFloat(productCard.dataset.productPrice) || 0,
        stock: totalStock
      };
    }
    product.quantity++;
    this.selectedProducts.set(productId, product);
    this.updateProductCard(productCard, product.quantity, availableStock);
    this.updateUI();
  }

  removeProduct(productCard) {
    const productId = productCard.dataset.productId;
    const totalStock = parseInt(productCard.dataset.productStock) || 0;
    const availableStock = this.getAvailableStock(productId, totalStock);
    let product = this.selectedProducts.get(productId);
    if (!product || product.quantity === 0) return;
    product.quantity--;
    if (product.quantity === 0) {
      this.selectedProducts.delete(productId);
    } else {
      this.selectedProducts.set(productId, product);
    }
    this.updateProductCard(productCard, product.quantity, availableStock);
    this.updateUI();
  }

  clearSelection() {
    this.selectedProducts.clear();
    this.productsGrid.querySelectorAll('.product-card').forEach(card => {
      const totalStock = parseInt(card.dataset.productStock) || 0;
      const productId = card.dataset.productId;
      const availableStock = this.getAvailableStock(productId, totalStock);
      card.classList.remove('selected', 'stock-limit');
      const badge = card.querySelector('.product-quantity-badge');
      badge.style.display = 'none';
      badge.textContent = '0';
      const addBtn = card.querySelector('.btn-add-corner');
      if (addBtn) addBtn.disabled = totalStock > 0 && availableStock <= 0;
    });
    this.updateUI();
  }

  updateProductCard(productCard, quantity, availableStock) {
    const badge = productCard.querySelector('.product-quantity-badge');
    const addBtn = productCard.querySelector('.btn-add-corner');
    const totalStock = parseInt(productCard.dataset.productStock) || 0;
    if (quantity > 0) {
      productCard.classList.add('selected');
      badge.textContent = quantity;
      badge.style.display = 'flex';
    } else {
      productCard.classList.remove('selected', 'stock-limit');
      badge.style.display = 'none';
    }
    if (addBtn && totalStock > 0 && quantity >= availableStock) {
      addBtn.disabled = true;
      productCard.classList.add('stock-limit');
    } else if (addBtn) {
      addBtn.disabled = false;
      productCard.classList.remove('stock-limit');
    }
  }

  getTotalSelected() {
    let total = 0;
    this.selectedProducts.forEach(p => { total += p.quantity; });
    return total;
  }

  getTotalPrice() {
    let total = 0;
    this.selectedProducts.forEach(p => { total += p.price * p.quantity; });
    return total;
  }

  updateUI() {
    const totalSelected = this.getTotalSelected();
    const totalPrice = this.getTotalPrice();
    if (this.totalBeersEl) this.totalBeersEl.textContent = totalSelected;
    if (this.totalPriceEl) {
      if (this.discountCode && totalSelected === this.packSize) {
        const discounted = totalPrice * 0.95;
        this.totalPriceEl.innerHTML =
          `<s style="opacity:0.5;font-size:0.9em;">${totalPrice.toFixed(2)} €</s> ` +
          `<span style="color:#ff4d8f;">${discounted.toFixed(2)} €</span>`;
      } else {
        this.totalPriceEl.textContent = totalPrice.toFixed(2) + ' €';
      }
    }
    this.updateSelectedBeersGrid();
    const complete = totalSelected === this.packSize;
    if (this.addPackButton) {
      this.addPackButton.disabled = !complete;
      this.addPackButton.classList.toggle('enabled', complete);
    }
    if (this.checkoutButton) {
      this.checkoutButton.disabled = !complete;
      this.checkoutButton.classList.toggle('enabled', complete);
    }
    if (complete) {
      const msg = this.discountCode
        ? '¡Pack completo! Se aplicará un 5% de descuento al añadir al carrito.'
        : '¡Pack completo! Añádelo al carrito o ve directo a él.';
      this.showMessage(msg, 'success');
    } else if (totalSelected > 0) {
      const remaining = this.packSize - totalSelected;
      this.showMessage(`Te faltan ${remaining} cerveza${remaining !== 1 ? 's' : ''} para completar tu pack.`, 'info');
    } else {
      this.showMessage('', '');
    }
  }

  updateSelectedBeersGrid() {
    if (!this.selectedBeersGrid) return;
    const slots = this.selectedBeersGrid.querySelectorAll('.beer-slot');
    let currentIndex = 0;
    slots.forEach(slot => {
      slot.classList.remove('filled');
      slot.removeAttribute('data-product-id');
      slot.innerHTML = `<span>${slot.dataset.slot}</span>`;
    });
    this.selectedProducts.forEach((product, productId) => {
      for (let i = 0; i < product.quantity; i++) {
        if (currentIndex < slots.length) {
          const slot = slots[currentIndex];
          slot.classList.add('filled');
          slot.dataset.productId = productId;
          slot.innerHTML = product.image
            ? `<img src="${product.image}" alt="${product.title}" class="beer-slot-image"><span class="slot-remove-label">Quitar</span>`
            : `<span class="slot-letter">${product.title.charAt(0)}</span><span class="slot-remove-label">Quitar</span>`;
          currentIndex++;
        }
      }
    });
  }

  showMessage(message, type = 'info') {
    if (!this.messageEl) return;
    this.messageEl.textContent = message;
    this.messageEl.className = 'pack-message';
    if (type) this.messageEl.classList.add(`message-${type}`);
  }

  updateCartCount(itemCount) {
    if (window.Alpine) {
      const store = window.Alpine.store('xMiniCart');
      if (store) {
        if (typeof store.itemCount !== 'undefined') store.itemCount = itemCount;
        if (typeof store.count !== 'undefined') store.count = itemCount;
        if (typeof store.refresh === 'function') store.refresh();
      }
    }
    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble) {
      const countSpan = bubble.querySelector('span');
      if (countSpan) countSpan.textContent = itemCount;
      bubble.style.display = itemCount > 0 ? '' : 'none';
    }
    document.querySelectorAll('.count_item').forEach(el => {
      el.textContent = itemCount;
      el.style.display = itemCount > 0 ? '' : 'none';
    });
  }

  async applyDiscountCode(code) {
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: code })
      });
    } catch(e) {
      console.warn('No se pudo pre-aplicar el descuento:', e);
    }
  }

  // --- ATRIBUTO PACK-16 EN NOTE ATTRIBUTES ---
  // Siempre escribe '1' fijo — el procesador Shopify-Odoo solo necesita
  // detectar la presencia del atributo, no contar cuántos packs hay
  async updatePack16Attribute() {
    if (this.packSize !== 16) return;
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'pack-16': '1' } })
      });
      console.log('[pack-builder] Atributo pack-16 = 1');
    } catch(e) {
      console.warn('No se pudo actualizar el atributo pack-16:', e);
    }
  }

  async addPackToCart(goToCart) {
    const totalSelected = this.getTotalSelected();
    if (totalSelected !== this.packSize) {
      this.showMessage(`Debes seleccionar exactamente ${this.packSize} cervezas.`, 'error');
      return;
    }
    if (this.addPackButton) this.addPackButton.disabled = true;
    if (this.checkoutButton) this.checkoutButton.disabled = true;
    this.showMessage('Añadiendo cervezas al carrito...', 'info');
    try {
      const packId = `pack_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
      const items = [];
      this.selectedProducts.forEach((product, productId) => {
        if (product.quantity > 0) {
          items.push({
            id: productId,
            quantity: product.quantity,
            properties: { '_pack_id': packId, '_pack_size': this.packSize }
          });
        }
      });

      // 1. Añadir items al carrito
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!response.ok) throw new Error('Error al añadir al carrito');

      // 2. Actualizar cantidades locales
      await this.loadCartQuantities();

      // 3. Aplicar descuento via API (sin redirección)
      if (this.discountCode) await this.applyDiscountCode(this.discountCode);

      // 4. Escribir atributo pack-16: 1 fijo DESPUÉS del descuento
      await this.updatePack16Attribute();

      // 5. Leer carrito actualizado
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      this.updateCartCount(cart.item_count);

      if (goToCart) {
        window.location.href = '/cart';
      } else {
        const successMsg = this.discountCode
          ? '¡Pack añadido con 5% de descuento! Configura otro si quieres.'
          : '¡Pack añadido! Configura otro si quieres.';
        this.showMessage(successMsg, 'success');
        setTimeout(() => this.clearSelection(), 800);
      }
    } catch (error) {
      console.error('Error:', error);
      this.showMessage('Hubo un error al añadir las cervezas. Por favor, inténtalo de nuevo.', 'error');
      if (this.addPackButton) { this.addPackButton.disabled = false; this.addPackButton.classList.add('enabled'); }
      if (this.checkoutButton) { this.checkoutButton.disabled = false; this.checkoutButton.classList.add('enabled'); }
    }
  }
}

document.addEventListener('DOMContentLoaded', () => { new PackBuilder(); });
